export default __webpack_public_path__ + "static/media/hero-memories@2x.124ebc06.webp";